import { useQuery } from '@tanstack/react-query';
import { fetchQuestionBankSubTopics } from '../services/questionBankTopicService';

export function useQuestionBankSubTopics(params = {}, options = {}) {
  return useQuery({
    queryKey: ['questionBankSubTopics', params],
    queryFn: async () => {
      const { payload } = await fetchQuestionBankSubTopics(params);

      return {
        subTopicLang: payload?.sub_topic_lang || 'Sub Topics',
        stateName: payload?.state_name || '',
        categoryName: payload?.category_name || '',
        topicName: payload?.topic_name || '',
        topicList: Array.isArray(payload?.topic_list) ? payload.topic_list : [],
        pagination: payload?.pagination || {},
      };
    },
    enabled: options.enabled ?? true,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    retry: 2,
    refetchOnMount: "always",
    refetchOnWindowFocus: false,
    refetchOnReconnect: true,
    placeholderData: (previousData) =>
      previousData ?? {
        subTopicLang: 'Sub Topics',
        stateName: '',
        categoryName: '',
        topicName: '',
        topicList: [],
        pagination: {},
      },
  });
}
